import { IReportRequest } from 'peekdata-datagateway-api-sdk';
import { IReport } from 'src/models/report';
import { AsyncState, IAction, IAsyncState } from 'src/state/action';
import { actionTypes } from 'src/state/report/actions';

// #region -------------- State -------------------------------------------------------------------

export interface IReportState {
  report: IAsyncState<IReport>;
  reportTitle: string;
  savedReportStatus: IAsyncState<IReport>;
  isModalOpen: boolean;
}

const initialState = {
  report: new AsyncState(),
  reportTitle: '',
  savedReportStatus: new AsyncState(),
  isModalOpen: false,
};

// #endregion

// #region -------------- Reducer -------------------------------------------------------------------

export function reportReducer(state: IReportState = initialState, action: IAction): IReportState {
  let reportData: IReport;

  switch (action.type) {
    case actionTypes.setReportRequest:
      const dataRequest: IReportRequest = action.payload;

      return {
        ...state,
        report: {
          ...state.report,
          data: {
            ...state.report.data,
            dataRequest,
          },
        },
      };

    case actionTypes.loadReport:
      return {
        ...state,
        report: {
          ...state.report,
          isFetching: true,
          timestamp: new Date(),
        },
      };

    case actionTypes.reportLoaded:
      reportData = action.payload && action.payload.data;

      return {
        ...state,
        reportTitle: reportData ? reportData.title : '',
        report: {
          ...state.report,
          ...action.payload,
        },
      };

    case actionTypes.reportSaved:
      return {
        ...state,
        report: {
          ...state.report,
          ...action.payload,
          error: null,
        },
        savedReportStatus: {
          ...state.savedReportStatus,
          ...action.payload,
        },
      };

    case actionTypes.openModal:
      reportData = state.report && state.report.data;

      return {
        ...state,
        reportTitle: reportData ? reportData.title : '',
        savedReportStatus: new AsyncState(),
        isModalOpen: true,
      };

    case actionTypes.closeModal:
      return {
        ...state,
        isModalOpen: false,
      };

    case actionTypes.changeReportTitle:
      return {
        ...state,
        reportTitle: action.payload,
      };

    case actionTypes.removeMessage:
      return {
        ...state,
        savedReportStatus: {
          ...state.savedReportStatus,
          data: null,
        },
      };

    default:
      return state;
  }
}

// #endregion
